import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["title", "disabled", "type"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_wave = _resolveDirective("wave")!

  return _withDirectives((_openBlock(), _createElementBlock("button", {
    class: _normalizeClass([
			'c-button',
			`c-button-${_ctx.type}`,
			{ [_ctx.activeClass]: _ctx.isActive },
			{ [_ctx.disabledClass]: _ctx.disabled },
		]),
    title: _ctx.disabled ? _ctx.disabledTitle : _ctx.title,
    disabled: _ctx.disabled,
    type: _ctx.elementType
  }, [
    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
  ], 10, _hoisted_1)), [
    [_directive_wave, !_ctx.disabled]
  ])
}